/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PeopleCircle1Icon20Solid = forwardRef('PeopleCircle1Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM5.334 14.38C5.957 11.786 8.606 11.6 10 11.6c1.394 0 4.043.186 4.666 2.78A6.382 6.382 0 0 1 10 16.4a6.382 6.382 0 0 1-4.666-2.02ZM10 10.2a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6Z" })));
});
